import { Status } from "src/app/modules/my-board/interfaces/board.interfaces";

export const groupBy = <T, K extends keyof any>(array: T[], key: (i: T) => K) =>
  array.reduce((groups, item) => {
    (groups[key(item)] ||= []).push(item);
    return groups;
  }, {} as Record<K, T[]>);

export function groupByToArray(arrayObjects: any[], key: string) {
  return arrayObjects.reduce(function (result, currentObject) {
    const val = currentObject[key];
    result[val] = result[val] || [];
    result[val].push(currentObject);
    return result;
  }, []);
}

export function groupByToArray2(arrayObjects: any[], key: string) {
  const grouped = arrayObjects.reduce((result, currentObject) => {
    const val = currentObject[key];
    const objectWithStatus = {
      ...currentObject,
      status: {
        sName: '',
        icIcon: '',
        cssIcon: ''
      } as Status
    };
    result[val] = result[val] || [];
    result[val].push(objectWithStatus);
    return result;
  }, {} as Record<string, any[]>);

  return Object.values(grouped);
}


export function groupByToArrayToTask(arrayObjects: any[], key: string) {
  return arrayObjects.reduce(function (result, currentObject) {
    const val = currentObject[key];
    result[val] = result[val] || [];
    result[val].push(currentObject);
    return result;
  }, {} as Record<string, any[]>);
}
